import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const departments = [
    { name: "About Department", key: "about" },
    { name: "Courses Offered", key: "courses" },
    { name: "Faculty Members", key: "faculty" },
    { name: "Timetable", key: "timetable" },
    { name: "Facilities", key: "facilities" },
    { name: "Seminars/Conferences/Workshops", key: "events" },
    { name: "Research Scholars", key: "researchScholars" },
    { name: "Achievements", key: "achievements" },
    { name: "Contact", key: "contact" },
];

// Content for each section, structured as an object
const departmentContent = {
    about: (
        <div className="mb-4">
            <h4 className="mb-3 text-primary">Department of Grammar</h4>
            <p className="mb-3">
                The ultimate well-being, both worldly and otherworldly, of all living
                beings is possible only through Indian culture. Today's scientific
                community is also beginning to realize this. The foundation of this
                ancient culture is Sanskrit literature. Our ancient culture is based on
                Sanskrit texts, thus Sanskrit and culture - both mutually dependent -
                are still established as the prestige of India. As it is said:
            </p>
            <blockquote className="blockquote text-center my-4">
                <p className="mb-0">भारतस्य प्रतिष्ठे द्वे संस्कृत संस्कृतिस्तथा।</p>
            </blockquote>
            <p className="mb-3">
                Thus, culture is based on Sanskrit, and Sanskrit is also fully
                described in Sanskrit grammar, meaning grammar is the expounder of
                Sanskrit.
            </p>
            <p className="mb-3">
                "Vyakriyante Vyutpadyante'nena Shabdaah" (The scripture by which words
                are derived is called Grammar). The word 'Vyakarana' is derived from
                'Vi + Aa + Kri + Lyut'. Grammar is the expounder of the correctness and
                incorrectness of words, hence, without grammar, it is impossible to
                know Sanskrit accurately. According to the commentator,
                "JnanapurvakaPrayoge Dharmah" (Dharma is in the conscious use),
                accordingly, to know this divine language Sanskrit and attain
                immortality like it, grammar is the best and simplest means. The
                fundamental texts of Indian culture are the Vedas, and proper knowledge
                of the Vedas is not possible without grammar. Therefore, grammar is
                called the mouth among the six limbs of the Vedas. Hence, the study of
                grammar should be done as a matter of Dharma without any specific
                reason. This Sanskrit grammar is of many kinds due to different
                originators, among which nine grammars are very famous. Although the
                word derivation process of all these grammars is different, the sole
                objective of all is the perfection of the established word. In the world
                of grammar, the word as 'Sphota' is established as 'Shabda Brahma' and
                is therefore eternal, beginningless, and one.
            </p>
            <p className="mb-3">
                Grammar originated from Brahma. Therefore, for the attainment of
                Dharma, Artha, Kama, and Moksha, grammar is the only royal path. Hence,
                it is to be studied.
            </p>
            <p className="mb-3">
                In the direction of enriching Indian culture, the Department of Grammar
                at Maharishi Valmiki Sanskrit University, Kaithal, has been making an
                uninterrupted contribution since 2018. In this department, mainly
                ancient and modern grammar subjects are taught, along with Sanskrit
                conversation to refine male and female students. Imparting proper
                knowledge of history, geography, sacrificial traditions, etc., through
                the Sutras of Ashtadhyayi, shows the distinctiveness of the Grammar
                Department.
            </p>
            <h5 className="mt-4 mb-3 text-secondary">Objectives –</h5>
            <ol className="mb-4">
                <li className="mb-2">
                    To achieve proficiency in writing, reading, and speaking along with
                    the understanding of grammar, which is the means of expression.
                </li>
                <li className="mb-2">
                    To clarify the role of grammar in the preservation of Sanskrit
                    scriptures, the transfer of scriptural tradition, and its factual
                    validation.
                </li>
                <li className="mb-2">
                    For the establishment of grammatical principles with a modern
                    understanding of their scientific and social implications.
                </li>
                <li className="mb-2">
                    To develop linguistic proficiency in students based on grammatical
                    usage and linguistic analysis.
                </li>
                <li className="mb-2">
                    For the protection of the nature of the Sanskrit language and
                    linguistic purity.
                </li>
                <li>For the knowledge of grammatical elements.</li>
            </ol>
        </div>
    ),
    courses: (
        <div className="mb-4">
            <h4 className="mb-3 text-primary">Courses Offered</h4>
            <ul className="list-unstyled">
                <li className="mb-2">
                    <i className="bi bi-book-fill me-2"></i> Shastri (Grammar)
                </li>
                <li className="mb-2">
                    <i className="bi bi-book-fill me-2"></i> Acharya (Grammar)
                </li>
                <li className="mb-2">
                    <i className="bi bi-book-fill me-2"></i> Vidyavaridhi (Ph.D.)
                </li>
            </ul>
        </div>
    ),
    faculty: (
        <div className="mb-4">
            <h4 className="mb-3 text-primary">Faculty Members</h4>
            <h5 className="mb-3 text-secondary">Total Faculty – 02 (Regular)</h5>
            <div className="table-responsive">
                <table className="table table-bordered table-striped table-hover align-middle">
                    <thead className="table-primary text-center">
                        <tr>
                            <th>Photo</th>
                            <th>Name</th>
                            <th>Designation</th>
                            <th>Highest Qualification</th>
                            <th>Contact</th>
                            <th>Email</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        <tr>
                            <td style={{ width: "140px" }}>
                                <img
                                    src={require("../assets/Photos/डॉ. सुरेन्द्र पाल वत्स (विभागाध्यक्ष, व्याकरण).jpg")}
                                    alt="Dr. Surendra Pal"
                                    className="img-fluid rounded"
                                    style={{ height: "120px", objectFit: "cover" }}
                                />
                            </td>
                            <td>Dr. Surendra Pal</td>
                            <td>Head of Department, Associate Professor</td>
                            <td>Ph.D., NET</td>
                            <td>9896335373</td>
                            <td><a href="mailto:hodvyakaran@mvsu.ac.in">hodvyakaran@mvsu.ac.in</a></td>
                        </tr>
                        <tr>
                            <td>
                                <img
                                    src={require("../assets/Photos/डॉ. शर्मिला (व्याकरण विभाग).jpg")}
                                    alt="Dr. Sharmila"
                                    className="img-fluid rounded"
                                    style={{ height: "120px", objectFit: "cover" }}
                                />
                            </td>
                            <td>Dr. Sharmila</td>
                            <td>Assistant Professor</td>
                            <td>M.Phil., Ph.D., NET, JRF</td>
                            <td>9254640788</td>
                            <td><a href="mailto:omsharmila88@gmail.com">omsharmila88@gmail.com</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    ),

    timetable: (
        <div className="mb-4">
            <h4 className="mb-3 text-primary">Timetable</h4>
            <p className="text-muted">Timetable will be available soon.</p>
        </div>
    ),
    facilities: (
        <div className="mb-4">
            <h4 className="mb-3 text-primary">Facilities</h4>
            <ol className="mb-3">
                <li className="mb-2">
                    Students are provided with subject-specific knowledge along with
                    Sanskrit conversation practice.
                </li>
                <li className="mb-2">
                    Training for various competitive examinations is provided, such as
                    UGC NET examination, CTET, B.Ed., TGT (Sanskrit), PGT (Sanskrit)
                    training, etc.
                </li>
                <li className="mb-2">
                    Various competitions are organized from time to time to enhance
                    mental knowledge.
                </li>
            </ol>
        </div>
    ),
    events: (
        <div className="mb-4">
            <h4 className="mb-3 text-primary">Seminars/Conferences/Workshops</h4>
            <p className="text-muted">
                Information regarding seminars/conferences/workshops will be available
                soon.
            </p>
        </div>
    ),
    researchScholars: (
        <div className="mb-4">
            <h4 className="mb-3 text-primary">Research Scholars</h4>
            <h5 className="mb-3 text-secondary">
                Details of students registered for Vidyavaridhi (Ph.D.) degree –
            </h5>
            <div className="table-responsive">
                <table className="table table-bordered table-striped table-hover align-middle">
                    <thead className="table-dark">
                        <tr>
                            <th scope="col">Researcher</th>
                            <th scope="col">Supervisor</th>
                            <th scope="col">Topic</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Rishu</td>
                            <td>Dr. Surendra Pal</td>
                            <td>(Topic will be available soon)</td>
                        </tr>
                        <tr>
                            <td>Rahul</td>
                            <td>Dr. Surendra Pal</td>
                            <td>(Topic will be available soon)</td>
                        </tr>
                        <tr>
                            <td>Anil Kumar</td>
                            <td>Dr. Surendra Pal</td>
                            <td>(Topic will be available soon)</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    ),
    achievements: (
        <div className="mb-4">
            <h4 className="mb-3 text-primary">Achievements</h4>
            <h5 className="mb-3 text-secondary">Employed Students:</h5>
            <ul className="list-unstyled">
                <li className="mb-2">
                    <i className="bi bi-award-fill text-warning me-2"></i> Smt. Monika
                    (Working as Sanskrit Lecturer in Haryana Education Department)
                </li>
                <li className="mb-2">
                    <i className="bi bi-award-fill text-warning me-2"></i> Ms. Rishu
                    (Working as Sanskrit Lecturer in Haryana Education Department)
                </li>
                <li className="mb-2">
                    <i className="bi bi-award-fill text-warning me-2"></i> Ms. Maafi
                    (Working in Postal Department in Uttar Pradesh Government)
                </li>
            </ul>
            <h5 className="mt-4 mb-3 text-secondary">UGC NET Qualified Students:</h5>
            <ol className="list-unstyled">
                <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-success me-2"></i> Smt.
                    Monika
                </li>
                <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-success me-2"></i> Ms.
                    Krishna
                </li>
                <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-success me-2"></i> Ms.
                    Rita
                </li>
                <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-success me-2"></i> Ms.
                    Shivani
                </li>
                <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-success me-2"></i> Shri
                    Vikas Kumar
                </li>
            </ol>
            <h5 className="mt-4 mb-3 text-secondary">JRF Qualified Students:</h5>
            <ol className="list-unstyled">
                <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-success me-2"></i> Ms.
                    Poonam Devi
                </li>
                <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-success me-2"></i> Shri
                    Naveen Sharma
                </li>
            </ol>
        </div>
    ),
    contact: (
        <div className="mb-4">
            <h4 className="mb-3 text-primary">Contact</h4>
            <div className="table-responsive mb-4">
                <table className="table table-bordered table-striped table-hover align-middle">
                    <thead className="table-dark">
                        <tr>
                            <th scope="col">S.No.</th>
                            <th scope="col">Name</th>
                            <th scope="col">Position</th>
                            <th scope="col">Contact Number</th>
                            <th scope="col">Email</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1.</td>
                            <td>Dr. Surendra Pal</td>
                            <td>Head of Department, Associate Professor</td>
                            <td>9896335373</td>
                            <td>
                                <a href="mailto:hodvyakaran@mvsu.ac.in">
                                    hodvyakaran@mvsu.ac.in
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td>2.</td>
                            <td>Dr. Sharmila</td>
                            <td>Assistant Professor</td>
                            <td>9254640788</td>
                            <td>
                                <a href="mailto:omsharmila88@gmail.com">
                                    omsharmila88@gmail.com
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            {/* Moved the non-academic staff table here as a separate table */}
            <h5 className="mb-3 mt-4 text-secondary">Non-Academic Staff Contact:</h5>
            <div className="table-responsive mb-4">
                <table className="table table-bordered table-striped table-hover align-middle">
                    <thead className="table-dark">
                        <tr>
                            <th scope="col">S.No.</th>
                            <th scope="col">Name</th>
                            <th scope="col">Position</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1.</td>
                            <td>Shri Sitaram</td>
                            <td>Clerk (HKRN)</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    ),
};

export default function GrammarDepartment_Eng() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [activeIndex, setActiveIndex] = useState(0); // State to manage active sidebar item

    const handleItemClick = (index) => {
        setActiveIndex(index);
        // Hide sidebar on small screens after an item is clicked
        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };

    // Get the key for the currently active department to fetch its content
    const activeDepartmentKey = departments[activeIndex].key;

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle Button for Small Screens */}
            <button
                className="btn btn-primary d-md-none m-2 shadow-sm"
                onClick={() => setShowSidebar(!showSidebar)}
            >
                ☰ Menu
            </button>

            {/* Sidebar (Collapsible on small screens) */}
            <aside
                className={`bg-white text-dark p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none"
                    } d-md-flex col-md-3 border-end`}
            >
                <h5 className="text-center fw-bold mb-4 text-dark border-bottom pb-2">
                    Department of Grammar
                </h5>
                <div className="flex-grow-1 overflow-auto pe-2">
                    {departments.map((dept, index) => (
                        <p
                            key={dept.key}
                            className={`mb-2 p-2 rounded small cursor-pointer ${activeIndex === index
                                ? "bg-primary text-white shadow-sm"
                                : "bg-light text-dark hover-effect"
                                }`}
                            onClick={() => handleItemClick(index)}
                            style={{
                                cursor: "pointer",
                                transition: "background-color 0.3s ease, color 0.3s ease",
                            }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            {/* Main Content */}
            <main className="flex-grow-1 p-4 bg-white shadow col-md-9 overflow-auto">
                {departmentContent[activeDepartmentKey]}
            </main>

            {/* Optional: Add a simple CSS for hover effect */}
            <style jsx>{`
        .hover-effect:hover {
          background-color: #e2e6ea !important;
          color: #000 !important;
        }
      `}</style>
        </div>
    );
}